export const initialState = localStorage.getItem("store")
  ? JSON.parse(localStorage.getItem("store"))
  : 1;

export const setStore = (store, storeM2) => {
  store.setState({ store: storeM2 }, () =>
    localStorage.setItem("store", storeM2)
  );
};
